import React, { useEffect, useState } from 'react'
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  ReferenceLine
} from 'recharts'

const AccelerometerLineChart = props => {
  const { data, config } = props.getProps()
  const [, stateUpdate] = useState('')
  useEffect(() => {
    props.linkStateUpdater(stateUpdate)
  }, [])

  const [defaultXAxisConfig] = config.xAxisList
  const [defaultYAxisConfig] = config.yAxisList
  return (
    <div style={{ width: '100%', height: '100%', margin: '0 auto' }}>
      <ResponsiveContainer width='100%' height='100%'>
        <LineChart
          data={data}
          margin={{
            top: 20,
            right: 0,
            left: 0,
            bottom: 0
          }}
        >
          <CartesianGrid
            stroke='rgba(255, 255, 255, 0.5)'
            strokeDasharray='0'
            strokeWidth={1}
            yAxis={defaultYAxisConfig.name}
          />
          <XAxis
            xAxisId={defaultXAxisConfig.name}
            dataKey={defaultXAxisConfig.name}
            height={1}
            orientation='top'
            type='number'
            tick={{
              fill: '#fff'
            }}
            tickLine={false}
            domain={defaultXAxisConfig.scale}
            {...{
              ...(defaultXAxisConfig.ticksList && {
                ticks: defaultXAxisConfig.ticksList
              })
            }}
            tickFormatter={(v, index) => (index % 2 === 0 ? '' : v)}
            strokeWidth={0}
          />
          {config.yAxisList.map((yAxisConfig, index) => (
            <React.Fragment key={yAxisConfig.name}>
              <YAxis
                yAxisId={yAxisConfig.name}
                domain={yAxisConfig.scale}
                strokeWidth={0}
                {...(yAxisConfig.ticksList
                  ? {
                      width: 1,
                      tick: {
                        fill: '#fff',
                        dy: -10
                      },
                      ticks: yAxisConfig.ticksList,
                      tickLine: false,
                      orientation: 'right',
                      tickMargin: -10,
                      label: {
                        position: 'insideLeft',
                        stroke: '#fff',
                        fontSize: '8px'
                      },
                      textAnchor: 'end',
                      tickFormatter: v => (v < 0 ? '' : v)
                    }
                  : {
                      width: 0
                    })}
              />
              <Line
                xAxisId={defaultXAxisConfig.name}
                yAxisId={yAxisConfig.name}
                type='monotone'
                dataKey={yAxisConfig.name}
                stroke={yAxisConfig.stroke}
                dot={false}
              />
              <ReferenceLine
                xAxisId={defaultXAxisConfig.name}
                yAxisId={yAxisConfig.name}
                y={data[0][yAxisConfig.name]}
                strokeWidth={0}
                label={{
                  position: 'insideLeft',
                  value: yAxisConfig.title,
                  stroke: '#fff',
                  fontSize: '12px'
                }}
              />
            </React.Fragment>
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}
export default AccelerometerLineChart
